import throttleUtility from 'javascripts/modules/util.throttle.js';
import VisibilityState 	from 'javascripts/modules/visibility-state.js';

(function($){

  $(function() {

    var el = $('.tpl-category-echos-publishing__loader');
    el.hide();
 
    if(el[0]){
      $(window).on('scroll', throttleUtility(function(e){
     
       var offset = el.offset(); 
        var loading = el.data('load');
        var count = el.data('count');
        var taxonomy = el.data('taxonomy');
        var page_current = parseInt(el.data('page')) + 1 ;
   
        if(!loading && (offset.top-$(window).height() <= $(window).scrollTop()) && (($('.tpl-category-echos-publishing__content li').length % count)== 0)) {
            el.data('load',true);
            el.show();

            

            var filters = $(".filters-layout input:checkbox:checked").map(function(){
                return $(this).val();
            }).get();
          
              var data = {
                action: 'filter_posts',
                afp_nonce: afp_vars.afp_nonce,
                taxonomy :taxonomy,
                count : count,
                page : page_current,
                filters : filters,
                infinite : true
              };

           

              $.ajax({
                type: 'post',
                url: afp_vars.afp_ajax_url,
                data: data,
                dataType : 'html',
                success: function( data, textStatus, XMLHttpRequest ) {
                  if($.trim(data) != ''){
                     $('.tpl-category-echos-publishing__content li:last-child').after(data);
                     setTimeout(function(){
                        el.data('load',false);
                        this.elements = document.querySelectorAll('[data-visibility]');
                        const visibility    = new VisibilityState();
                        visibility.refresh(this.elements);
                      },1000);
                     
                     el.data('page',page_current);
                     
                     
                     el.hide();
                  }else{
                   
                  }
                },
                error: function( MLHttpRequest, textStatus, errorThrown ) {
                  console.log(textStatus);
                }
              });
        }


    }, 300));
    }
    
    
      
  });

})(jQuery);